export default __webpack_public_path__ + "static/media/logo-green.2353b04f.png";